var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text",class:{'has-after': _vm.item.headline}},[_c('div',{staticClass:"wrap"},[(_vm.item.headline)?_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.item.headline))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-body",domProps:{"innerHTML":_vm._s(_vm.item.body)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c097a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/text.vue
// module id = null
// module chunks = 